function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { guid } from "@bydesign-ui/utils";
export var SubCollapse = function () {
  function SubCollapse(root) {
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var insId = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, SubCollapse);

    this.parent = null;
    this.id = '';
    this.subCollapseMap = {};
    this.isDispose = false;
    this.type = '';
    this.rootCollapse = root;
    this.parent = parent;
    this.insId = insId || guid();
    this.rootCollapse.registerSubCollapse(this);

    if (this.parent) {
      this.parent.registerSubCollapse(this);
    }
  }

  _createClass(SubCollapse, [{
    key: "updateSubCollapseOption",
    value: function updateSubCollapseOption(options) {
      var id = options.id,
          _options$type = options.type,
          type = _options$type === void 0 ? '' : _options$type;
      this.id = id;
      this.type = type;

      if (this.isOpened() && this.parent && this.parent.getType() === this.type) {
        this.parent.updateOpened(true);
      }
    }
  }, {
    key: "updateOpened",
    value: function updateOpened(open) {
      this.doSetOpened(open);
      this.rootCollapse.emitOpenIdsChange();
    }
  }, {
    key: "setOpened",
    value: function setOpened(open) {
      this.doSetOpened(open);
      this.rootCollapse.emitOpenIdsChange();
    }
  }, {
    key: "updateParentOpenedState",
    value: function updateParentOpenedState(open) {
      var parent = this.parent;

      while (parent) {
        parent.updateOpenedState(open);
        parent = parent.parent;
      }
    }
  }, {
    key: "updateChildOpenedState",
    value: function updateChildOpenedState(open) {
      var _this = this;

      Object.keys(this.subCollapseMap).forEach(function (insId) {
        var collapseItem = _this.subCollapseMap[insId];
        var opened = collapseItem.isOpened();

        if (open !== opened) {
          collapseItem.updateOpenedState(open);
          collapseItem.isSubCollapse() && collapseItem.updateChildOpenedState(open);
        }
      });
    }
  }, {
    key: "updateOpenedState",
    value: function updateOpenedState(open) {
      if (this.isOpened() === open) {
        return;
      }

      this.rootCollapse.setOpen(this.insId, this.id, open);
    }
  }, {
    key: "isSubCollapse",
    value: function isSubCollapse() {
      return true;
    }
  }, {
    key: "isOpened",
    value: function isOpened() {
      return this.rootCollapse.isOpened(this.id);
    }
  }, {
    key: "getInsId",
    value: function getInsId() {
      return this.insId;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.type;
    }
  }, {
    key: "getInsIdsPath",
    value: function getInsIdsPath() {
      var ids = [this.insId];

      if (this.parent) {
        return this.parent.getInsIdsPath().concat(ids);
      }

      return ids;
    }
  }, {
    key: "registerSubCollapse",
    value: function registerSubCollapse(subCollapse) {
      var id = subCollapse.getInsId();

      if (this.subCollapseMap[id]) {
        throw new Error("id=".concat(id, " subCollapse have been registered"));
      }

      this.subCollapseMap[id] = subCollapse;
    }
  }, {
    key: "unregisterSubCollapse",
    value: function unregisterSubCollapse(subCollapse) {
      var id = subCollapse.getInsId();

      if (!this.subCollapseMap[id]) {
        throw new Error("id=".concat(id, " subCollapse have been unregistered"));
      }

      delete this.subCollapseMap[id];
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var _this2 = this;

      if (this.isDispose) {
        return;
      }

      this.isDispose = true;
      this.rootCollapse.unregisterSubCollapse(this);
      this.parent && this.parent.unregisterSubCollapse(this);
      Object.keys(this.subCollapseMap).forEach(function (id) {
        return _this2.subCollapseMap[id] && _this2.subCollapseMap[id].dispose();
      });
    }
  }, {
    key: "doSetOpened",
    value: function doSetOpened(open) {
      if (this.rootCollapse.getAccordion()) {
        if (this.parent) {
          this.parent.updateChildOpenedState(false);
        } else {
          this.rootCollapse.setOpenIds([]);
        }
      }

      if (open && this.parent) {
        this.updateParentOpenedState(open);
      } else if (!open) {
        this.updateChildOpenedState(open);
      }

      this.updateOpenedState(open);
    }
  }]);

  return SubCollapse;
}();